
$(document).ready(function() {


//qty click
$(document).on('click','.template-product .product-form__quantity .qty-selector-options button.qty-selector-option',function(){
  $(this).siblings('.qty-selector-option').removeClass('active');
  $(this).addClass('active');

  // var div_index = $(this).index();
  // div_index = div_index + 1;
  // $('.template-product .product-form__quantity quantity-input input[name="quantity"]').val(div_index);

  var get_val = $(this).attr('data-val');
  $('variant-selects fieldset input[value="'+get_val+'"]').next('label').trigger('click');
});

var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 200);
}
ALAcheck();
function customALA() {
var selector = $('.rc-template__radio');
  if(selector.length > 0) {
    clearInterval(isALARendered);        
    var text = $(selector).find('.onetime-radio .rc-radio__label').text();
    if(text.includes('$')){
      var new_text = text.split('$')[0];
      var price = $('.product__info-container .price .price-item').html();
      var final_text = '<span class="rc-radio__one_time">'+new_text+'</span><span class="rc-radio__price">'+price+'</span>';
      $(selector).find('.onetime-radio .rc-radio__label').html(final_text);
    }

    //on load
    // if($(selector).find('.onetime-radio').hasClass('rc-radio--active')){
    //   $('product-info .subscription-benefit').show();
    // }else{
    //   $('product-info .subscription-benefit').hide();
    // }

    //on change
    // $(selector).find('input[type="radio"]').on('change',function(){
    //   if($(selector).find('.onetime-radio').hasClass('rc-radio--active')){
    //     $('product-info .subscription-benefit').show();
    //   }else{
    //     $('product-info .subscription-benefit').hide();
    //   }
    // });
    
  }  
}

$(document).on('click','variant-selects fieldset label',function(){
  console.log('clicked')
  setTimeout(function() {
    if($('.rc-template__radio .onetime-radio .rc-radio__label .rc-radio__one_time').length > 0){
      var price = $('.product__info-container .price .price-item').html();
      $('.rc-template__radio .onetime-radio .rc-radio__label .rc-radio__price').html(price);
    }else{
      var text = $('.rc-template__radio').find('.onetime-radio .rc-radio__label').text();
      if(text.includes('$')){
        var new_text = text.split('$')[0];
        var price = $('.product__info-container .price .price-item').html();
        var final_text = '<span class="rc-radio__one_time">'+new_text+'</span><span class="rc-radio__price">'+price+'</span>';
        $('.rc-template__radio').find('.onetime-radio .rc-radio__label').html(final_text);
      }
    }
  }, 1200);
});

  $('.slider .list-wrap').slick({
    speed: 5000,
	autoplay: true,
	autoplaySpeed: 0,
    arrows:false,
	cssEase: 'linear',
    slidesToShow: 7,
  	slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
  	centerMode: true,
    focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1350,
          settings: {
            slidesToShow: 6, 
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4, 
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint:820,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

    if ($(window).width()>750) {
   
    $('.review_slider').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows:true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint:989 ,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

      
    }




   // Show the first tab and hide the rest
    // $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content.active').show();
    // $('#tabs-nav li.active').trigger('click');
    
    // Click function
    $('#tabs-nav li').click(function(){
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();

       var desk_package = $('.bundle-option-drawer .bundle-main-content .package-desk');
       $(desk_package).find('.cstm_select_btn').removeClass('selected');
       $(desk_package).find('.subscrive_save').removeClass('open');
       $(desk_package).find('.subscrive_save .disc_cols').addClass('hidden');
      if($(this).hasClass('subscription')){
        $('.bundle-option-drawer .bundle-main-content .package-desk .cstm_select_btn.subscription_btn').addClass('selected');
        $('.bundle-option-drawer .bundle-main-content .package-desk .subscrive_save.subscription').addClass('open');
        $('.bundle-option-drawer .bundle-main-content .package-desk .subscrive_save.subscription .disc_cols ').removeClass('hidden');
        $('.package-desk .atc_bundle_btn').insertBefore('.package-desk .package_list');
        $('.rc-template__radio .subscription-radio').trigger('click');
      }else{
        $('.bundle-option-drawer .bundle-main-content .package-desk .cstm_select_btn.one_time_btn ').addClass('selected');
        $('.bundle-option-drawer .bundle-main-content .package-desk .subscrive_save.one-time').addClass('open');
        $('.bundle-option-drawer .bundle-main-content .package-desk .subscrive_save.one-time .disc_cols ').removeClass('hidden');
        $('.package-desk .atc_bundle_btn').insertBefore('.package-desk .bundle-footer');
        $('.rc-template__radio .onetime-radio').trigger('click');
      }
      $('.package-desk .atc_bundle_btn:gt(0)').remove();
      
      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });



  //Ak custom code
  //product page custom recharge JS
  var subscription_pro = $('.custom-subscription');
  
  if(subscription_pro.length > 0){

        var isALARenderedsub;
        function ALAchecksub() {
          isALARenderedsub = setInterval(function () {
            customALAsub()
          }, 200);
        }
        ALAchecksub();
        function customALAsub() {
        var selector = $('.rc-template__radio');
          if(selector.length > 0) {
               clearInterval(isALARenderedsub);  
              $('.shopify-app-block.recharge-subscription-widget').addClass('hidden');

              // if($(selector).find('.subscription-radio').hasClass('rc-radio--active')){
              //   // $('product-info .subscription-benefit').show();
              //   $('.bundle-option-drawer .bundle-main-content .package-desk .cstm_select_btn.subscription_btn').trigger('click');
              //      // $('#tabs-nav li.subscription').trigger('click');
              // }else{
              //   $('.bundle-option-drawer .bundle-main-content .package-desk .cstm_select_btn.one_time_btn').trigger('click');
              //     // $('#tabs-nav li.subscription').trigger('click');
              // }
            
            $('.bundle-option-drawer .bundle-main-content .package-desk .cstm_select_btn.subscription_btn').trigger('click');

          }  
        }

        //open drawer
        $(document).on('click','.custom-subscription .cstm-sub-btn button',function(){
          var drawer_subs = $('.bundle-option-drawer');
          if(drawer_subs.length > 0){
            var get_class = $(drawer_subs).attr('addclass');
            $(drawer_subs).addClass(get_class);
    
            $(drawer_subs).find('.bundle-drawer-heading .close-bundle-drawer button.modal-popup__close').on('click',function(){
              $(drawer_subs).removeClass(get_class);
            });
          }
        });
    
        //out side click of drawer
        $(document).mouseup(function(e){
          var container = $(".bundle-option-drawer");
          var get_class = $(container).attr('addclass');
          // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
              $(container).removeClass(get_class);
            }
        });


        //on subscription click
        $(document).on('click','.bundle-option-drawer .bundle-main-content .package-desk .cstm_select_btn',function(){
           var desk_package = $('.bundle-option-drawer .bundle-main-content .package-desk');
           $(desk_package).find('.cstm_select_btn').removeClass('selected');
           $(desk_package).find('.subscrive_save').removeClass('open');
           $(desk_package).find('.subscrive_save .disc_cols').addClass('hidden');
           $(this).addClass('selected');
           $(this).closest('.subscrive_save').addClass('open');
           $(this).next('.disc_cols').removeClass('hidden');

           if($(this).hasClass('subscription_btn')){
             $('.package-desk .atc_bundle_btn').insertBefore('.package-desk .package_list');
             $('.rc-template__radio .subscription-radio').trigger('click');
             $('.bundle-option-drawer .bundle-main-content .packge-mob ul li.subscription').trigger('click');
           }else{
             $('.package-desk .atc_bundle_btn').insertBefore('.package-desk .bundle-footer');
             $('.rc-template__radio .onetime-radio').trigger('click');
             $('.bundle-option-drawer .bundle-main-content .packge-mob ul li.one_time').trigger('click');
           }
           $('.package-desk .atc_bundle_btn:gt(0)').remove();
        });

        //on qty buttons click
        $(document).off('change', '.bundle-option-drawer .bundle-main-content .disc_cols input')
           .on('change', '.bundle-option-drawer .bundle-main-content .disc_cols input', function() {
           var qty_val = $(this).val();
          console.log("Quantity Value:"+qty_val);
          $('product-form form input.quantity__input').val(qty_val);
          $('.bundle-option-drawer .bundle-main-content .disc_cols input[value="'+qty_val+'"]').next().trigger('click');
          
          console.log("Price In Element:"+$(this).attr('data-pro-price'));
          var pro_price = parseInt($(this).attr('data-pro-price'));
          var discount_val = parseInt($(this).attr('data-discount-val'));
          //var per_val = parseInt($(this).attr('data-per-qty'));
          var per_val = $(this).attr('data-per-qty');
          var per_pieace_text = $(this).closest('.subscrive_save').find('.cstm_select_btn .select_price').next('p').attr('data-per-text');
          console.log("per_val:"+per_val);
          var variant_id = $(this).data('variant-id');
          console.log("Variant ID:", variant_id);
          console.log("VARIANT ID:"+variant_id);
          var multi_qty = pro_price * parseInt(qty_val);
          // console.log(multi_qty);
          console.log(multi_qty+"="+pro_price+"x"+parseInt(qty_val));
          var discounted_price = multi_qty - (multi_qty * discount_val / 100); // Applying discount
          console.log(discounted_price+"="+multi_qty+"- ("+multi_qty+"x"+discount_val+"/100)");

          if(multi_qty > discounted_price){
            var price_html = '<span>'+Shopify.formatMoney(multi_qty, '${{amount}}')+'</span>' + Shopify.formatMoney(discounted_price, '${{amount}}');
            $(this).closest('.subscrive_save').find('.cstm_select_btn .select_price').html(price_html);

            var per_price_final_price = discounted_price / per_val;
             console.log("PER CHEW PRICE:"+per_price_final_price+"="+discounted_price+"/"+per_val);
            var per_price_main_html = 'Only ' + Shopify.formatMoney(per_price_final_price, '${{amount}}') +' '+ per_pieace_text;
            $(this).closest('.subscrive_save').find('.cstm_select_btn .select_price').next('p').html(per_price_main_html);
          }else{
            var price_html =  Shopify.formatMoney(multi_qty, '${{amount}}');
            $(this).closest('.subscrive_save').find('.cstm_select_btn .select_price').html(price_html);

            var per_price_final_price = multi_qty / per_val;
            var per_price_main_html = 'Only ' + Shopify.formatMoney(per_price_final_price, '${{amount}}') +' '+ per_pieace_text;
            $(this).closest('.subscrive_save').find('.cstm_select_btn .select_price').next('p').html(per_price_main_html);
          }
        });

        //on atc cart button click
        $(document).on('click','.bundle-option-drawer .bundle-main-content .atc_bundle_btn button',function(){
           var $this = $(this);
           $($this).addClass('loading');
           $($this).find('.loading__spinner').removeClass('hidden');

          setTimeout(function() {
            $($this).removeClass('loading');
            $($this).find('.loading__spinner').addClass('hidden');

            var drawer_subs = $('.bundle-option-drawer');
            if(drawer_subs.length > 0){
              var get_class = $(drawer_subs).attr('addclass');
              $(drawer_subs).removeClass(get_class);
            }
          }, 1200);

          $('product-form form .product-form__buttons button').trigger('click');
        });
  }
  //End Ak custom code


});


// document.addEventListener("DOMContentLoaded", function() {
//   setTimeout(function() {
//    var elements = document.querySelectorAll('.subscription-radio,.rc-selling-plans');
//     var wrapper = document.createElement('div');
//     wrapper.className = 'custom_Wrap_app';
//     elements[0].parentNode.insertBefore(wrapper, elements[0]);
//     elements.forEach(function(element) {
//     wrapper.appendChild(element); 
//   });
//     }, 1000); 
// });




 function checkScroll() {
   
            const scrollHeight = 1300; // Set your specific scroll height here
            if (window.scrollY > scrollHeight) {
                document.body.classList.add('scrolled');
            } else {
                document.body.classList.remove('scrolled');
            }
        }

        // Check on initial load (if needed)
        checkScroll();

        // Check on scroll
        window.addEventListener('scroll', checkScroll);

// Select the element with the class "best_value"
let element = document.querySelector('.best_value');

// Change its text content
if (element) {
    element.textContent = 'Best Value';
}

/*  =======     Changing default checkbox to subscription =============*/
/*     Add paw logo in footer heading */

document.querySelectorAll('h2.footer-block__heading.inline-richtext').forEach((heading) => {
  if (heading.textContent.trim() === 'Petibles') {
    // Clear the heading
    heading.innerHTML = '';

    // Add the class for styling
    heading.classList.add('has-logo');

    // --- Main Petibles logo (not clickable) ---
    const mainLogo = document.createElement('div');
    mainLogo.className = 'footer-logo-image';
    heading.appendChild(mainLogo);

    // --- BBB logo below (clickable) ---
    const bbbWrapper = document.createElement('div');
    bbbWrapper.className = 'bbb-logo-wrapper';

    const bbbLink = document.createElement('a');
    bbbLink.href = 'https://www.bbb.org/us/fl/miami/profile/pet-supplies/petibles-llc-0633-92046408/#sealclick';
    bbbLink.target = '_blank';
    bbbLink.rel = 'nofollow';
    bbbLink.className = 'bbb-logo-link';

    const bbbImg = document.createElement('img');
    bbbImg.src = 'https://cdn.shopify.com/s/files/1/0883/2234/3195/files/Untithled_design.png?v=1761920680';
    bbbImg.alt = 'Petibles LLC. BBB Business Review';
    bbbImg.className = 'bbb-logo-img';

    // Append BBB image inside the link
    bbbLink.appendChild(bbbImg);
    bbbWrapper.appendChild(bbbLink);

    // Append both logos inside the heading
    heading.appendChild(mainLogo);
    heading.appendChild(bbbWrapper);
  }
});

/*  =======     Hiding Main Code =============*/
// document.querySelectorAll('h2.footer-block__heading.inline-richtext').forEach((heading) => {
//     if (heading.textContent.trim() === 'Petibles') {
//         heading.innerHTML = ' '; // Remove inner content
//         heading.classList.add('has-logo'); // Add the class for styling
//     }
// });

// Select the parent div
const parentDiv = document.querySelector('.page-width.center.page-width--narrow.section-template--24062982029595__main-padding');

// Check if the parent div exists
if (parentDiv) {
  // Remove the 'page-width--narrow' class
  parentDiv.classList.remove('page-width--narrow');
}

 
document.addEventListener('DOMContentLoaded', () => {
  // Select all elements with the class .text-container
  const textContainers = document.querySelectorAll('.text-container');

  // Loop through each .text-container
  textContainers.forEach((textContainer) => {
    // Check if the container includes the specific paragraphs
    const paragraphs = textContainer.querySelectorAll('p');
    const firstParagraph = paragraphs[0];
    const secondParagraph = paragraphs[1];

    if (
      firstParagraph &&
      firstParagraph.textContent.startsWith('Chase is our beloved emotional support dog') &&
      secondParagraph &&
      secondParagraph.textContent.startsWith('Living in a bustling household')
    ) {
      // Apply styles to this specific container
      textContainer.style.display = 'flex';
      textContainer.style.flexDirection = 'column';
      textContainer.style.alignItems = 'center';
      textContainer.style.justifyContent = 'center';
      textContainer.style.height = '400px'; // Adjust the height as needed
      textContainer.style.textAlign = 'center'; // Optional: align text center horizontally

      // Remove margin from paragraphs for better alignment
      paragraphs.forEach((paragraph) => {
        paragraph.style.margin = '0';
      });
    }
  });
});


// /*      FLOATING BUTTON HOMEPAGE HEADER SECTION BUTTON        */ 
// $(document).ready(function () {
//   const parent = $('#ImageWithText--template--24062981964059__image_with_text_VjzbAj'); // Parent element
//   const button = parent.find('.btn_wrap'); // Button inside the parent
//   const headerHeight = parent.outerHeight(); // Get the height of the parent header

//   // Add scroll event listener
//   $(window).on('scroll', function () {
//     if ($(window).scrollTop() > headerHeight) {
//       // Add 'fixed' class and apply styles dynamically
//       button.addClass('fixed').css({
//         'border': '1px solid white',
//         'border-radius': '9px',
//         'box-shadow': '2px 2px 10px rgba(0, 0, 0, 0.1)'
//       });
//     } else {
//       // Remove 'fixed' class and reset styles
//       button.removeClass('fixed').css({
//         'border': '',
//         'border-radius': '',
//         'box-shadow': ''
//       });
//     }
//   });
// });


$(document).ready(function () {
  const parent = $('#ImageWithText--template--24062981964059__image_with_text_VjzbAj');
  const button = parent.find('.btn_wrap');
  const headerHeight = parent.outerHeight();
  const footer = $('.footer.color-scheme-2');

  function updateButtonPosition() {
    const windowWidth = $(window).width();
    const buttonWidth = button.outerWidth();
    const centerPosition = (windowWidth - buttonWidth) / 2;
    return centerPosition;
  }

  $(window).on('scroll', function () {
    const scrollTop = $(window).scrollTop();
    const footerOffset = footer.offset().top;
    const windowHeight = $(window).height();
    const centerPosition = updateButtonPosition();
    const isMobile = $(window).width() <= 768; // Detect mobile devices

    // Check if footer is coming into view
    if (footerOffset - (scrollTop + windowHeight) < 100) {
        // Fade out before footer
        button.css({
            'position': 'fixed',
            'bottom': isMobile ? '0px' : '30px', // Adjust for mobile
            'left': centerPosition,
            'opacity': '0',
            'transition': 'opacity 0.3s ease',
            'z-index': '999'
        });
    } else if (scrollTop > headerHeight) {
        // Floating behavior
        button.css({
            'position': 'fixed',
            'bottom': isMobile ? '0px' : '30px', // Adjust for mobile
            'left': centerPosition,
            'opacity': '1',
            'border': '1px solid white',
            'border-radius': '9px',
            'box-shadow': '2px 2px 10px rgba(0, 0, 0, 0.1)',
            'transition': 'opacity 0.3s ease',
            'z-index': '999',
            'padding-top': '0px'
        });
    } else {
        // Original position
        button.css({
            'position': '',
            'bottom': '',
            'left': '',
            'opacity': '1',
            'border': '',
            'border-radius': '',
            'box-shadow': '',
            'transition': '',
            'z-index': ''
        });
    }
});


  // Update position on window resize
  $(window).on('resize', function() {
    $(window).trigger('scroll');
  });
  
  // Initial trigger
  $(window).trigger('scroll');
});





/*     ADD SUBTITLE FAQ SECTION */

document.addEventListener('DOMContentLoaded', () => {
  const parentElement = document.querySelector('#shopify-block-simesy_faq_tabs_accordion_simesy_faq_U7QPzH');
  if (parentElement) {
    const subtitle = document.createElement('p');
    subtitle.className = 'sub_title';
    subtitle.textContent = 'FAQ';

    // Add inline styles
    subtitle.style.color = '#9aca3b';
    subtitle.style.border = 'solid 1px #9aca3b';
    subtitle.style.padding = '4px 30px';

    parentElement.insertBefore(subtitle, parentElement.querySelector('h2'));
  }
});
 

/*   CUSTOM CODE FOR OPENING CHOOSE PACKAGES WITH A LINK */ 
document.addEventListener('DOMContentLoaded', () => {
  console.log("DOM LOADED");
    const urlParams = new URLSearchParams(window.location.search);
    const packageParam = urlParams.get('package');

    if (packageParam === '23435223') {
      console.log("FOUND PARAM");
      const button = document.querySelector('.custom-subscription .button--primary');
      setTimeout(() => {
        if (button) {
          console.log("trigering click");
          button.click();
        }
      }, 2000); 
    }
  });

$(document).on('click', '.quick-add .quick-add__submit', function(e) {
    e.preventDefault();
    e.stopPropagation();

    // Get the product URL and package ID from the button's data attributes
    const productUrl = $(this).data('product-url');
    const packageId = $(this).data('package-id');

    // Redirect to the product page with the package query parameter
    if (productUrl && packageId) {
        const redirectUrl = `${productUrl}?package=${packageId}`;
        window.location.href = redirectUrl;
    } else {
        console.error('Product URL or package ID is missing.');
    }
});


(function(e,t,n){var r,i=e.getElementsByTagName(t)[0];if(e.getElementById(n))return;r=e.createElement(t);r.id=n;r.src="https://button.aftership.com/all.js?username=e017a479";i.parentNode.insertBefore(r,i)})(document,"script","aftership-jssdk")


/*=============== Center Align a text on homepage ========================*/ 
document.querySelectorAll('.multi-images ul.content_lists p').forEach(p => {
    if (p.textContent.startsWith("Check out ")) {
        p.classList.add('custom-center'); // Add the class to center-align
    }
});

function addCustomClassToButton() {
  // Get all buttons with the class `.button.button--primary`
  const buttons = document.querySelectorAll('a.button.button--primary');

  // Loop through all buttons
  buttons.forEach(button => {
    // Check if the button's text content is "Keep Reading"
    if (button.textContent.trim() === "Keep Reading") {
      // Add the custom class to the button
      button.classList.add('custom-center-button');
    }
  });
}

// Run the function on page load
addCustomClassToButton();

//hiding one time button of probiotic-1

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
      if (window.location.href.includes("/products/probiotic-chews-1")) {
        // Hide the one-time block
        var oneTimeBlock = document.querySelector(".subscrive_save.one-time");
        if (oneTimeBlock) {
          oneTimeBlock.style.display = "none";
        }

        // Replace "10%" with "72%" in all matching <h3> elements
        document.querySelectorAll(".custom-subscription .cstm-sub-text h3").forEach(el => {
          if (el.innerHTML.includes("40%")) {
            el.innerHTML = el.innerHTML.replace("40%", "72%");
          }
        });
      }
    }, 500);
  });

/*  ===========================   TESTIMONIALS AUTO SCROLL CODE ==============================*/

document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.review_slider');

  sliders.forEach((slider) => {
    let scrollAmount = 0;
    const scrollStep = 1; // Speed
    const scrollInterval = 20; // Delay in ms

    function autoScroll() {
      scrollAmount += scrollStep;
      if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
        scrollAmount = 0;
      }
      slider.scrollLeft = scrollAmount;
    }

    setInterval(autoScroll, scrollInterval);
  });
});


/*============      Product page specification TAB active on load ====================*/

  document.addEventListener("DOMContentLoaded", function () {
    const defaultTab = document.querySelector('button#ruby');
    const defaultPanel = document.querySelector('div[aria-labelledby="ruby"]');

    // Deselect all tabs and hide all panels
    document.querySelectorAll('[role="tab"]').forEach(tab => tab.setAttribute('aria-selected', 'false'));
    document.querySelectorAll('[role="tabpanel"]').forEach(panel => panel.setAttribute('hidden', ''));

    // Select the default tab and show its panel
    if (defaultTab && defaultPanel) {
      defaultTab.setAttribute('aria-selected', 'true');
      defaultPanel.removeAttribute('hidden');
    }
  });


